import { PiMapPin, PiMapPinFill } from 'react-icons/pi'

/**
 * Map-pin icon for the doors "Place URL" column. Renders both stroke and
 * fill variants; CSS in main.css scoped to .fb-plain-links toggles visibility
 * based on hover of the icon wrapper (matches MenuIcon's behavior).
 */
export function PlaceUrlIcon({
  size = 20,
  className = '',
}: {
  size?: number
  className?: string
}) {
  return (
    <span className="fb-menu-icon-wrap inline-flex">
      <PiMapPin
        size={size}
        className={`fb-menu-icon-stroke ${className}`.trim()}
      />
      <PiMapPinFill
        size={size}
        className={`fb-menu-icon-fill ${className}`.trim()}
      />
    </span>
  )
}
